import React, { Component } from 'react'
import './Users.css'
import * as languageSettings from '../Language/languageSettings'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Pagination from '../Common/Pagination'
import t from '../Language/language'
import { Config } from '../../Config'
import { initViewStore } from '../../actions/viewDetails'
import { getUsers, sortUsers, setSearchParams, paginationUsers, setUUID } from '../../actions/users'
import { checkAccess, getPermission } from '../../actions/permissions'
import whiteplus from '../../images/whiteplus.png'
import AuthenticationService from '../Security/AuthenticationService'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import CommonLoader from '../Alerts/CommonLoader'
import { CommonConstants } from '../../Constants'
import CommonSearch from '../Common/Search'
class Users extends Component {
  constructor (props) {
    super(props)
    this.state = {
      showStores: this.props.showStores,
      language: languageSettings.getCurrentLanguage(),
      Ascending: true,
      criteria: null,
      pageSize: 10,
      offset: 0,
      data: [],
      recordCount: 5000,
      pageNumber: null,
      showCommonLoader: true,
      forcePage: null,
      searchOptions: [
        { value: 'User_FirstName', name: 'Search first name' },
        { value: 'User_LastName', name: 'Search last name' },
        { value: 'User_EmailAddress', name: 'Search username' },
        { value: 'Company_Name', name: 'Search company name' }
      ]
    }
    this.PageSizeValueDropdown = this.PageSizeValueDropdown.bind(this)
    this.PageClicked = this.PageClicked.bind(this)
    this.search = this.search.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.authService = new AuthenticationService(Config.authBaseUrl)
    this.state.url = this.authService.getColdFusionAppUrl(this.authService.isAdmin())
    this.props.getPermission()
  }

  handleClick (did) {
    if (this.authService.isAdmin()) {
      window.location.href = '/admin/settings/users/user?uuid=' + did
    } else {
      window.location.href = '/settings/users/user?uuid=' + did
    }
  }

  componentWillMount () {
    if (this.authService.getSelectedMenu() === 'users') {
      // clearing the ViewingAsOwner data if selected menu is not accounts in admin.
      this.authService.clearViewingAsOwner()
    }
    // default sorting on column
    this.props.sortUsers({ 'sortBy': 'User_EmailAddress', 'sortType': 'ASC' })
    this.props.setSearchParams({ 'filter': null, 'criteria': null })
    const params = new URLSearchParams(this.props.history.location.search)
    const uuid = params.get('uuid') ? params.get('uuid') : null
    uuid ? this.props.setUUID(uuid) : this.authService.clearUUID(uuid)
    this.props.getUsers(() => {
      this.setState({ showCommonLoader: false })
    })
    /// change to callback function as the sync function was not working.
  }

  search (selectedFilter, criteria) {
    // search on filter and criteria
    if (criteria) {
      this.setState({ showCommonLoader: true, forcePage: 0, offset: 0 })
      this.props.setSearchParams({ 'filter': selectedFilter, 'criteria': criteria })
      this.props.getUsers(() => {
        this.setState({ showCommonLoader: false })
      })
    } else {
      this.props.setSearchParams({ 'filter': null, 'criteria': null })
      window.location.href = '/admin/settings/users'
    }
  }

  onEnterPress (e) {
    // handelling on enter key search
    if (e.key === 'Enter') {
      this.setState({ showCommonLoader: true })
      if (this.state.criteria) {
        this.props.setSearchParams({ 'filter': this.props.users.searchParams.filter, 'criteria': this.state.criteria })
        this.props.getUsers(() => {
          this.setState({ showCommonLoader: false })
        })
      } else {
        this.props.setSearchParams({ 'filter': null, 'criteria': null })
        window.location.href = '/admin/settings/users'
      }
    }
  }

  // on change of dropdown values for number of records per page in pagination
  PageSizeValueDropdown (pageSize) {
    this.setState({ pageSize, showCommonLoader: true, forcePage: 0, offset: 0 })
    let paginationParams = { pageSize: pageSize, pageNumber: 1 }
    this.props.paginationUsers(paginationParams)
    this.props.getUsers(() => {
      this.setState({ showCommonLoader: false })
    })
  }

  // on click of page number
  PageClicked (value) {
    this.setState({ showCommonLoader: true, forcePage: null })
    let paginationParams = { pageSize: this.state.pageSize, pageNumber: ((value / this.state.pageSize) + 1) }
    this.setState({ pageNumber: paginationParams.pageNumber })
    this.props.paginationUsers(paginationParams)
    this.props.getUsers(() => {
      this.setState({ showCommonLoader: false })
    })
    if (value === null) {
      return this.state.offset
    } else {
      this.setState({ offset: value })
      return this.state.offset
    }
  }
  handleSearchChange (e) {
    this.props.setSearchParams({ 'filter': e.target.value, 'criteria': null })
  }
  handleCriteria (e) {
    this.setState({ [e.target.name]: e.target.value })
  }

  render () {
    const { language } = this.state
    let sortParams = (this.props.users.sortParams) ? this.props.users.sortParams : { 'sortBy': 'Brand_Name', 'sortType': 'DESC' }
    let recordCount = (this.props.users.pageDetails !== undefined) ? this.props.users.pageDetails.RecordCount : 10
    let pageCount = (this.props.users.pageDetails !== undefined) ? this.props.users.pageDetails.TotalPages : 10
    return (
      <section className='users'>
        <div className='settings forms'>
          <div className='settings_plug clear'>
            <div className='settings_search clear'>
              <div className='systemsHeader usersSection'>
                <h3 className='clear' style={{ margin: '0px' }}>{t[language].homepageUsers}</h3>
                <div className='usersSearch'>
                  <div className={!this.authService.isAdmin() ? 'hidden' : ''}>
                    <CommonSearch onSearch={this.search}
                      searchOptions={this.state.searchOptions} />
                  </div>
                </div>
              </div>
              <div style={{ marginTop: '20px' }} className={checkAccess(CommonConstants.userPermissions.AddUser) ? 'addUserButton' : 'hidden'}>
                <span className='additem' onClick={this.addUser.bind(this)}>
                  <img src={whiteplus} className='whiteplus' alt='Add User' />
                  {t[language].addauser}
                </span>
              </div>
            </div> <div className='settings_plug clear storeHeight' />
            <div className='settings_list'>
              <div className='ctable'>
                <Table>
                  <Thead>
                    <Tr className='theader clear'>
                      <Th className={(checkAccess(CommonConstants.userPermissions.EditUser)) ? '' : 'hidden'} />
                      <Th id='User_EmailAddress' className={(sortParams.sortBy === 'User_EmailAddress' && sortParams.sortType === 'ASC') ? 'actcold' : ((sortParams.sortBy === 'User_EmailAddress' && sortParams.sortType === 'DESC') ? 'actcol' : '')}>
                        <a><span id='User_EmailAddress' onClick={this.sortStores.bind(this)}>{t[language].username}</span></a>
                      </Th>
                      <Th className={(sortParams.sortBy === 'User_FirstName' && sortParams.sortType === 'ASC') ? 'actcold' : ((sortParams.sortBy === 'User_FirstName' && sortParams.sortType === 'DESC') ? 'actcol' : '')}>
                        <a><span id='User_FirstName' onClick={this.sortStores.bind(this)}>{t[language].firstname}</span></a>
                      </Th>
                      <Th className={(sortParams.sortBy === 'User_LastName' && sortParams.sortType === 'ASC') ? 'actcold' : ((sortParams.sortBy === 'User_LastName' && sortParams.sortType === 'DESC') ? 'actcol' : '')}>
                        <a><span id='User_LastName' onClick={this.sortStores.bind(this)}>{t[language].lastname}</span></a>
                      </Th>
                      <Th className={(sortParams.sortBy === 'Company_Name' && sortParams.sortType === 'ASC') ? 'actcold' : ((sortParams.sortBy === 'Company_Name' && sortParams.sortType === 'DESC') ? 'actcol' : (!this.authService.isAdmin() ? ' hidden' : ''))}>
                        <a><span id='Company_Name' onClick={this.sortStores.bind(this)}>{t[language].companyname}</span></a>
                      </Th>
                      <Th className={(sortParams.sortBy === 'Company_AvanteCust_ID' && sortParams.sortType === 'ASC') ? 'actcold' : ((sortParams.sortBy === 'Company_AvanteCust_ID' && sortParams.sortType === 'DESC') ? 'actcol' : (!this.authService.isAdmin() ? ' hidden' : ''))}>
                        <a><span id='Company_AvanteCust_ID' onClick={this.sortStores.bind(this)}>{t[language].avantenum}</span></a>
                      </Th>
                      <Th className={(sortParams.sortBy === 'Role_Name' && sortParams.sortType === 'ASC') ? 'actcold' : ((sortParams.sortBy === 'Role_Name' && sortParams.sortType === 'DESC') ? 'actcol' : '')}>
                        <a><span id='Role_Name' onClick={this.sortStores.bind(this)}>{t[language].role}</span></a>
                      </Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {!this.state.showCommonLoader ? this.renderUsers() : '' }
                  </Tbody>
                </Table>
                {this.state.showCommonLoader
                  ? <CommonLoader showLoader={this.state.showCommonLoader} message={'Loading...'} /> : ''
                }
                <div className={(!this.authService.isAdmin() ? ' hidden' : '')}>
                  <Pagination
                    perPage={this.state.pageSize}
                    PageSizeValueChange={this.PageSizeValueDropdown}
                    offset={this.PageClicked}
                    recordCount={recordCount}
                    pageCount={pageCount}
                    offSetValue={this.state.offset}
                    forcePage={this.state.forcePage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }

  // on click of sort ICON or column
  sortStores (e) {
    let sortBy = e.target.id
    let sortType = this.state.Ascending ? 'DESC' : 'ASC'
    let sortParams = { 'sortBy': sortBy, 'sortType': sortType }
    let Ascending = !this.state.Ascending
    this.setState({ showCommonLoader: true, Ascending })
    this.props.sortUsers(sortParams)
    this.props.getUsers(() => {
      this.setState({ showCommonLoader: false })
    })
  }
  addUser () {
    if (this.authService.isAdmin()) {
      window.location.href = '/admin/settings/users/user'
    } else {
      window.location.href = '/settings/users/user'
    }
  }

  // render users list
  renderUsers () {
    const { language } = this.state
    let self = this
    if (this.props.users) {
      if (this.props.users.usersDetails.length > 0) {
        let storeRows = this.props.users.usersDetails.map(function (user) {
          return (<Tr className='tdata clear'>
            <Td className={'view_details ' + (checkAccess(CommonConstants.userPermissions.EditUser) ? '' : 'hidden')}><a className='opener view_details' onClick={() => self.handleClick(user.User_UID)}><span>{t[language].viewedit}</span> <br /><span translate=''>{t[language].settingsUsersDetails}</span></a></Td>
            <Td>{user.User_EmailAddress}</Td>
            <Td>{user.User_FirstName}</Td>
            <Td>{user.User_LastName}</Td>
            <Td className={(!self.authService.isAdmin() ? ' hidden' : '')}>{user.Company_Name}</Td>
            <Td className={(!self.authService.isAdmin() ? ' hidden' : '')}>{user.Company_AvanteCust_ID}</Td>
            <Td>{user.Role_Name}</Td>
          </Tr>
          )
        })
        return storeRows
      } else {
        return (
          <tr className='tdata clear'><td colspan='8' className='accounts_table_noUsers'> <h3 className='noUsers'>No Users Found</h3> </td></tr>
        )
      }
    }
  }
}

function mapStateToProps (state) {
  return {
    users: state.users,
    permissions: state.userPermissions
  }
}
function matchDispatchToProps (dispatch) {
  return bindActionCreators(
    {
      getUsers: getUsers,
      sortUsers: sortUsers,
      setSearchParams: setSearchParams,
      paginationUsers: paginationUsers,
      initViewStore: initViewStore,
      setUUID: setUUID,
      getPermission: getPermission
    }, dispatch
  )
}
export default connect(mapStateToProps, matchDispatchToProps)(Users)



// WEBPACK FOOTER //
// ./src/components/Users/Users.js